import { ApiPaths } from "../../api/ApiPaths";
import { CareRecipientId } from "../../../domain/care_recipient/CareRecipientId";
import { ApiRequest } from "../../api/ApiRequest";
import { CareCommentId } from "../../../domain/care_comment/CareCommentId";
import { CareCommentThreadId } from "../../../domain/care_comment/CareCommentThreadId";

export type GetCareCommentListSuccessResponseType = {
    careCommentThreadList: {
        id: string,
        careRecipientId: string,
        createdTime: string,
        careCommentList: {
            id: string,
            title: string,
            content: string,
            createdTime: string,
            isRead: boolean,
        }[],
        isPinned: boolean
    }[],
    // API処理結果判別用：OK->undefined、NG->ErrorResponseType
    error: undefined
};

export async function getCareCommentList(
    careRecipientId: CareRecipientId
): Promise<GetCareCommentListSuccessResponseType> {
    return await ApiRequest.get(
        ApiPaths.careComment.list,
        {
            care_recipient_id: careRecipientId.value
        },
        () => {},
        () => {});
}

export async function markAsReadCareComment(
    careCommentIdList: CareCommentId[]
) {
    return await ApiRequest.post(
        ApiPaths.careComment.markAsRead,
        {},
        {
            careCommentIdList: careCommentIdList.map(careComment => careComment.value)
        },
        () => {},
        () => {});
}

export async function pinCareComment(
    careCommentThreadId: CareCommentThreadId
) {
    return await ApiRequest.post(
        ApiPaths.careComment.pin,
        {},
        {
            careCommentThreadId: careCommentThreadId.value
        },
        () => {},
        () => {});
}

export async function unpinCareComment(
    careCommentThreadId: CareCommentThreadId
) {
    return await ApiRequest.delete(
        ApiPaths.careComment.pin,
        {
            care_comment_thread_id: careCommentThreadId.value
        },
        () => {},
        () => {});
}